<template>
  <el-card class="h-full">
    <!-- input输入框部分 -->
    <div class="mb-20px">
      <el-input
        v-model="searchForm.alarmSource"
        class="mr-10px w-200px"
        placeholder="报警来源"
        clearable
      ></el-input>
      <el-select
        v-model="searchForm.isOpen"
        class="mr-10px w-200px"
        placeholder="是否开启"
        filterable
        clearable
      >
        <el-option
          v-for="item in enableList"
          :key="item.value"
          :value="item.value"
          :label="item.name"
        ></el-option>
      </el-select>
      <!-- button按钮部分 -->
      <el-button type="primary" @click="btnSearch" :disabled="!$hasAccess('check')">搜索</el-button>
      <el-button @click="reset" :disabled="!$hasAccess('check')">重置</el-button>
      <el-button @click="pushesVisible = true" :disabled="!$hasAccess('setPushes')"
        >推送设置</el-button
      >
      <el-button type="primary" @click="operate('create')" :disabled="!$hasAccess('create')"
        >新增</el-button
      >
    </div>
    <!-- 列表 -->
    <div class="h-[calc(100%-105px)]">
      <el-table
        :data="sourceList"
        v-loading="sourceLoading"
        row-key="id"
        border
        height="100%"
        stripe
        ref="tableRef"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" reserve-selection></el-table-column>
        <el-table-column type="index" label="序号" width="70"></el-table-column>
        <el-table-column
          prop="alarmSource"
          label="报警来源"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="是否开启" width="100px">
          <template slot-scope="{ row }">
            <el-switch @change="changeOpen($event, row)" v-model="row.isOpen"></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="alarmSoundName"
          label="报警声音"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="shadowName" label="特效" show-overflow-tooltip></el-table-column>
        <el-table-column prop="effectDuration" label="声光持续时长" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span>{{ row.effectDuration ? row.effectDuration + 's' : row.effectDuration }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="150px">
          <template slot-scope="{ row }">
            <el-button @click="operate('update', row)" size="mini" :disabled="!$hasAccess('update')"
              >编辑</el-button
            >
            <el-button @click="deleteSource(row)" size="mini" :disabled="!$hasAccess('delete')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt-20px flex justify-end">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="getSourceList"
        :current-page.sync="page.pageNo"
        :page-sizes="pageSizeAll"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
    <AddConfig
      v-if="addConfigVisible"
      :visible.sync="addConfigVisible"
      :shadowList="shadowList"
      :enableList="enableList"
      :schemeList="schemeList"
      :allSectionList="allSectionList"
      :operateType="operateType"
      :operateProps="operateProps"
      @refresh="getSourceList"
    ></AddConfig>
    <AlarmPushesSetting v-if="pushesVisible" :visible.sync="pushesVisible"></AlarmPushesSetting>
  </el-card>
</template>

<script>
import { isNil, map, cloneDeep, filter, forEach, isEmpty, find, nth, get, eq } from 'lodash'
import {
  SchemeApi,
  SectionApi,
  AlarmSourceConfigurationTableApi,
} from '@wiz-api/cloud-render-management'
import { FileApi } from '@wiz-api/file-management'

const schemeApi = new SchemeApi()
const sectionApi = new SectionApi()
const fileApi = new FileApi()
const alarmSourceConfig = new AlarmSourceConfigurationTableApi()

const AddConfig = () => {
  return import('../components/AlarmSource/AddConfig')
}

const AlarmPushesSetting = () => {
  return import('../components/AlarmSource/AlarmPushesSetting')
}

export default {
  components: {
    AddConfig,
    AlarmPushesSetting,
  },
  data() {
    return {
      searchForm: {
        alarmSource: '',
        isOpen: '',
      },
      // 光影下拉框选择
      shadowList: [
        {
          value: 0,
          name: '红色光影闪烁',
        },
      ],
      enableList: [
        {
          value: true,
          name: '开启',
        },
        {
          value: false,
          name: '关闭',
        },
      ],
      sourceList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      sourceLoading: false,
      selectSourceId: [],
      pageSizeAll: [15, 30, 45, 60, 75, 90],
      addConfigVisible: false,
      pushesVisible: false,
      operateType: '',
      operateProps: {},
      // 三维方案列表
      schemeList: [],
      // 板块列表
      allSectionList: [],
    }
  },
  created() {
    this.getSourceList()
    this.getSchemeList()
    this.getSectionList()
  },
  methods: {
    // 获取来源列表
    async getSourceList() {
      this.sourceLoading = true
      const [err, res] = await alarmSourceConfig.getAlarmSourceConfigurationList({
        ...this.searchForm,
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
      })
      if (!err && res) {
        this.sourceList = res.items
        forEach(this.sourceList, async (item, index) => {
          if (!isNil(item.shadow)) {
            const shadow = find(this.shadowList, ['value', item.shadow])
            if (!isEmpty(shadow)) {
              item.shadowName = shadow.name
            }
          }
          if (!isEmpty(item.alarmSoundId)) {
            const alarmSoundName = await this.getSoundName(item.alarmSoundId)
            if (eq(get(nth(this.sourceList, index), 'id'), item.id)) {
              this.$set(this.sourceList, index, { ...item, alarmSoundName })
            }
          }
        })
        this.page.total = res.totalCount
      }
      this.sourceLoading = false
    },
    // 获取图片
    async getSoundName(id) {
      const [err, res] = await fileApi.getFileContent(id)
      if (!err && !isNil(res)) {
        return res.name
      }
    },
    // 获取方案列表
    async getSchemeList() {
      const [err, res] = await schemeApi.getList({
        maxResultCount: 1000,
        skipCount: 0,
      })
      if (!err && res) {
        this.schemeList = res.items
      }
    },
    // 获取板块列表
    async getSectionList() {
      const [err, res] = await sectionApi.getList({
        maxResultCount: 1000,
        skipCount: 0,
      })
      if (!err && res) {
        this.allSectionList = res.items
      }
    },
    // 搜索按钮
    btnSearch() {
      this.$refs.tableRef.clearSelection()
      this.searchFenceList()
    },
    // 搜索
    searchFenceList() {
      this.page.pageNo = 1
      this.getSourceList()
    },
    // 重置
    reset() {
      // 重置搜索表单
      this.searchForm = this.$options.data().searchForm
      this.btnSearch()
    },
    // 操作
    operate(type, row) {
      this.addConfigVisible = true
      this.operateType = type
      if (type === 'create') {
        this.operateProps = {}
      } else {
        this.operateProps = row
      }
    },
    // 设置报警来源是否开启
    async changeOpen(value, row) {
      const [err, res] = await alarmSourceConfig.update(row.id, {
        body: {
          ...row,
          isOpen: value,
        },
      })
      if (!err) {
        this.$message.success({
          showClose: true,
          message: `${value ? '开启' : '关闭'}成功`,
        })
      }
    },
    // 删除配置
    deleteSource(row) {
      this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await alarmSourceConfig.callDelete(row.id)
        if (!err) {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.selectSourceId = filter(this.selectSourceId, row.id)
          this.$refs.tableRef.toggleRowSelection(row, false)
          this.getSourceList()
        }
      })
    },
    handleSizeChange(val) {
      this.page.pageNo = 1
      this.getSourceList()
    },
    handleSelectionChange(val) {
      this.selectSourceId = map(val, 'id')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
